import React, { useEffect, useState } from "react";
import "./LogoutPage.css";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";

const LogoutPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prevSeconds) => prevSeconds - 1);
    }, 1000);

    const timeout = setTimeout(() => {
      navigate("/login");
    }, 5000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <div className="logout-page">
      <div className="logout-container">
        <div className="logout-content">
          <FaCheckCircle size={60} color="green" />
          <h1>Logout Successful!</h1>
          <p className="logout-text-1">You’ve been successfully logged out.</p>
          <p className="logout-text-2">
            Redirecting to Login Page in {countdown} seconds
          </p>
          <button
            className="logout-login-button"
            onClick={() => navigate("/login")}
          >
            Back to Login Page
          </button>
          <p className="logout-footer-1">
            Powered by
            <p className="logout-footer-2">PNMB</p>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LogoutPage;
